import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/** Accesso tipizzato all'API .NET (gli indirizzi relativi "api/..." sono completati dall'interceptor). */
@Injectable({providedIn: 'root'})
export class ApiService
{
    constructor(private _http: HttpClient)
    {
    }

    get<T>(path: string, params?: Record<string, any>): Observable<T>
    {
        return this._http.get<T>(path, {params: this._params(params)});
    }

    post<T>(path: string, body: any = {}): Observable<T>
    {
        return this._http.post<T>(path, body);
    }

    put<T>(path: string, body: any = {}): Observable<T>
    {
        return this._http.put<T>(path, body);
    }

    delete<T = void>(path: string): Observable<T>
    {
        return this._http.delete<T>(path);
    }

    /** Scarica un file (Excel, PDF, immagine) e lo salva con il nome indicato. */
    download(path: string, fileName: string, params?: Record<string, any>): void
    {
        this._http.get(path, {params: this._params(params), responseType: 'blob'}).subscribe((blob) =>
        {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(url);
        });
    }

    /** Apre un file (es. PDF) in una nuova scheda. */
    open(path: string): void
    {
        this._http.get(path, {responseType: 'blob'}).subscribe((blob) =>
        {
            window.open(URL.createObjectURL(blob), '_blank');
        });
    }

    private _params(params?: Record<string, any>): HttpParams
    {
        let result = new HttpParams();
        Object.entries(params ?? {}).forEach(([key, value]) =>
        {
            if ( value !== null && value !== undefined && value !== '' )
            {
                result = result.set(key, String(value));
            }
        });
        return result;
    }
}
